import { render, staticRenderFns } from "./gritter.vue?vue&type=template&id=ba9f342a&scoped=true"
import script from "./gritter.vue?vue&type=script&lang=js"
export * from "./gritter.vue?vue&type=script&lang=js"
import style0 from "./gritter.vue?vue&type=style&index=0&id=ba9f342a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../shieldgo-admin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba9f342a",
  null
  
)

export default component.exports